import React from "react";
import * as CompareStyles from "./styles/CompareStyles";
import Icon from "../../../../common-deprecated/styles/v2/toyota/globals/Icon";
import { Separator } from "../../../../common-deprecated/styles/v2/toyota/globals/Separator";
import { useCompareV2Selector } from "../../redux/store";
import { CompareV2Label } from "../../utils/labels";
import { printPdf } from "../../../../common-deprecated/utils/pdfUtils";
import { getComparePDFLink } from "../../utils/utils";
import { trackComparePdf } from "../../utils/tracking";
import ButtonQuaternary from "../../../../common-deprecated/components/aem/toyota/ButtonQuaternary";

const PdfLink = (): JSX.Element => {
    const commonSettings = useCompareV2Selector((state) => state.commonSettings);
    const available = useCompareV2Selector((state) => state.newCarCompare.available);
    const compareContext = useCompareV2Selector((state) => state.newCarCompare.ncCompareContext);

    const sharePdf = (): void => {
        trackComparePdf();
        printPdf(getComparePDFLink(commonSettings, compareContext, available), commonSettings); // opens the PDF in new tab
    };

    return (
        <div>
            <Separator />
            <CompareStyles.PdfSection>
                {/* Button gets hidden by applying base style in the template */}
                <ButtonQuaternary hasIconRight onClick={() => sharePdf()}>
                    <Icon variant="download" />
                    <CompareV2Label label="compareBodySaveAsPdf" />
                </ButtonQuaternary>
            </CompareStyles.PdfSection>
        </div>
    );
};

export default PdfLink;
